
<div *ngIf="init">
    <dynamic-form  [layout]="alignMent" 
    [customField13]="0" [fields]="regConfig"
     (submitSubForm)="submitValue($event)">
    </dynamic-form>
</div>